import Vue from "vue";
// import "@fortawesome/fontawesome-free/css/all.css";
import Vuetify, {
  VApp, // required
  VNavigationDrawer,
  VFooter,
  VToolbar,
  VExpandTransition,
  VAlert,
  VAvatar,
  VBtn,
  VCard,
  VCardActions,
  VCardMedia,
  VCardText,
  VCardTitle,
  VCheckbox,
  VContainer,
  VContent,
  VDialog,
  VDialogTransition,
  VDivider,
  VBtnToggle,
  VFadeTransition,
  VFlex,
  VForm,
  VIcon,
  VHover,
  VImg,
  VInput,
  VLayout,
  VLabel,
  VItem,
  VItemGroup,
  VList,
  VListGroup,
  VListTile,
  VListTileAction,
  VListTileActionText,
  VListTileAvatar,
  VListTileContent,
  VListTileSubTitle,
  VListTileTitle,
  VToolbarItems,
  VToolbarSideIcon,
  VToolbarTitle,
  VMenu,
  VTimeline,
  VTimelineItem,
  VTextField,
  VSlider,
  VSpacer,
  VParallax,
  VSelect,
  VAutocomplete,
  VRadioGroup,
  VRadio,
  VCombobox,
  VScaleTransition,
  VSlideXTransition,
  VSlideXReverseTransition,
  VSlideYTransition,
  VSlideYReverseTransition,
  VDatePicker,
  VChip,
  VTextarea,
  VTooltip,
  VResponsive,
  VBadge,
  VRating,
  VSwitch,
  VProgressCircular
} from "vuetify/lib";

import { 
  Ripple,
  Touch
} from "vuetify/lib/directives"

import "vuetify/dist/vuetify.min.css";

// @ts-ignore
import Variables from "@/stylus/style-variables.json";

Vue.use(Vuetify, {
  components: {
    VApp,
    VNavigationDrawer,
    VFooter,
    VToolbar,
    VExpandTransition,
    VAlert,
    VAvatar,
    VBtn,
    VCard,
    VCardActions,
    VCardMedia,
    VCardText,
    VCardTitle,
    VCheckbox,
    VContainer,
    VContent,
    VDialog,
    VDialogTransition,
    VDivider,
    VBtnToggle,
    VFadeTransition,
    VFlex,
    VForm,
    VIcon,
    VHover,
    VImg,
    VInput,
    VLayout,
    VLabel,
    VItem,
    VItemGroup,
    VList,
    VListGroup,
    VListTile,
    VListTileAction,
    VListTileActionText,
    VListTileAvatar,
    VListTileContent,
    VListTileSubTitle,
    VListTileTitle,
    VToolbarItems,
    VToolbarSideIcon,
    VToolbarTitle,
    VMenu,
    VTimeline,
    VTimelineItem,
    VTextField,
    VSlider,
    VSpacer,
    VParallax,
    VSelect,
    VAutocomplete,
    VRadioGroup,
    VRadio,
    VCombobox,
    VScaleTransition,
    VSlideXTransition,
    VSlideXReverseTransition,
    VSlideYTransition,
    VSlideYReverseTransition,
    VDatePicker,
    VChip,
    VTextarea,
    VTooltip,
    VResponsive,
    VBadge,
    VRating,
    VSwitch,
    VProgressCircular
  },
  directives: {
    Ripple,
    Touch,
  },
  theme: {
    primary: Variables.colors.primary,
    secondary: Variables.colors.secondary,
    accent: Variables.colors.accent,
    error: Variables.colors.error,
    info: Variables.colors.info,
    success: Variables.colors.success,
    warning: Variables.colors.warning,
    defaultGray: Variables.colors.defaultGray,
    primary2: Variables.colors.primary2,
    primary3: Variables.colors.primary3,
    primary4: Variables.colors.primary4,
    primary5: Variables.colors.primary5,
    // primary: "#6247AA",
    // secondary: "#424242",
    // accent: "#82B1FF",
    // error: "#FF5252",
    // info: "#2196F3",
    // success: "#4CAF50",
    // warning: "#FFC107",
  },
  customProperties: true,
  iconfont: "fa",
  icons: {
    "radioOn": "far fa-dot-circle",
    "radioOff": "far fa-circle",
    "checkboxOn": "fas fa-check-square",
    "checkboxOff": "far fa-square",
    "check_circle": "check-circle",
    "account_circle": "user-circle",
    "plus": "plus",
    "minus": "minus",
    "save": "save",
    "sign_out": "sign-out-alt",
    "sign_in": "sign-in-alt",
    "gift": "gift",
    "info": "info",
    "info_circle": "info-circle",
    "child": "child",
    "walking": "walking",
    "hiking": "hiking",
    "delete_trash": "trash-alt",
    "more": "ellipsis-v",
    "edit": "pencil-alt",
    "mail": "envelope",
    "times_circle": "times-circle",
    "times": "times",
    "copy": "copy",
    "calendar": "calendar",
    "calendar_day": "calendar-day",
    "user_plus": "user-plus",
    "user_minus": "user-minus",
    "user_check": "user-check",
    "user_slash": "user-slash",
    "paper_plane": "paper-plane",
    "gifts": "gifts",
    "link": "link",
    "unlink": "unlink",
    "eshop": "shopping-cart",
    "image": "image",
    "money": "coins",
    "giving": "hand-holding",
    "ban": "ban",
    "frown": "frown",
    "warning": "exclamation-circle",
    "list": "list",
    "chevron_left": "chevron-left",
    "share": "share-alt",
    "clone": "clone",
    "friends": "user-friends",
    "circle": "circle",
    "question": "question-circle",
    "facebook": "facebook",
    "baby": "baby",
    "old_man": "blind",
    "magic": "magic"
  },
});
